import { PaletteMode } from "@mui/material";
import {
	IContextData,
	IDefaultTheme,
	IThemeData,
	ThemeAction,
	ThemeActionKind,
} from "./Entities";
import { createContext, useContext } from "react";

export const ThemeContext = createContext({} as IContextData);

const lightTheme: IThemeData = {
	mode: "light",
	color: "pink",
};

export const themes: IDefaultTheme[] = [
	{ name: "blue", palette: { primary: "#3f51b5", secondary: "#f50057" } },
	{ name: "pink", palette: { primary: "#880e4f", secondary: "#8bc34a" } },
	{ name: "green", palette: { primary: "#00c853", secondary: "#ffea00" } },
	{ name: "orange", palette: { primary: "#ef6c00", secondary: "#388e3c" } },
	{ name: "purple", palette: { primary: "#ab47bc", secondary: "#ff5722" } },
];

export function useVevyTheme(): IContextData {
	return useContext(ThemeContext);
}

export function themeReducer(theme: IThemeData, action: ThemeAction) {
	switch (action.action) {
		case ThemeActionKind.CHANGE_DARK_MODE:
			return changeDarkMode(action.payload, theme);
		case ThemeActionKind.CHANGE_COLOR:
			return changeThemeColor(action.payload, theme);
	}
	return theme;
}

export function InitContextData(): IThemeData {
	var localdata = localStorage.getItem("vevyTheme");
	return localdata !== null
		? (JSON.parse(localdata) as IThemeData)
		: lightTheme;
}

function changeDarkMode(payload: PaletteMode, state: IThemeData) {
	return {
		...state,
		mode: payload,
	};
}

function changeThemeColor(payload: string, state: IThemeData) {
	return {
		...state,
		color: payload,
	};
}
